import { ApiReportType } from '@kaiizen/kai-pro-api';
import { useCachedAsyncExport } from './useCachedAsyncExport';

/**
 * Hook to export a scan as PDF and poll for completion.
 *
 * For the given scan ID and options, it will prepare and eventually return the URL for the PDF.
 *
 * @param scanId - The scan ID to export, or null to disable
 * @param options - Polling options
 */
export const useScanPdfExport = (
  scanId: string | undefined,
  reportType: ApiReportType,
) =>
  useCachedAsyncExport({
    scanId,
    reportType,
    label: 'PDF',
    method: 'exportScopeReportPdf',
  });
